module.exports = __webpack_public_path__ + "public/img/yibiaopan_zi_33.6ebb4de7.png";